module.exports = __webpack_public_path__ + "hero_sale-ubiforward-right-cn.png";